import { render, staticRenderFns } from "./PlayerStatus.vue?vue&type=template&id=483a9b59&scoped=true&"
import script from "./PlayerStatus.vue?vue&type=script&lang=js&"
export * from "./PlayerStatus.vue?vue&type=script&lang=js&"
import style0 from "./PlayerStatus.vue?vue&type=style&index=0&id=483a9b59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a9b59",
  null
  
)

export default component.exports